import { render, staticRenderFns } from "./BaseDivider.vue?vue&type=template&id=f08e3178&scoped=true"
import script from "./BaseDivider.vue?vue&type=script&lang=ts"
export * from "./BaseDivider.vue?vue&type=script&lang=ts"
import style0 from "./BaseDivider.vue?vue&type=style&index=0&id=f08e3178&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08e3178",
  null
  
)

export default component.exports